import React from 'react';
import { InfoIcon, Text } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const ErrorMessage = ({ message, className }) => (
  <div className={`${cn('error-wrap')} ${className}`}>
    <div className={cn('error-icon', 'mar-r-2xs')}>
      <InfoIcon size={16} />
    </div>
    <Text color="grey60" size="size6-r">
      {message}
    </Text>
  </div>
);

ErrorMessage.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};
